import { render } from "./Competition.vue?vue&type=template&id=514b9810"
import script from "./Competition.vue?vue&type=script&lang=js"
export * from "./Competition.vue?vue&type=script&lang=js"
script.render = render

export default script